import { useEffect } from 'react'

import { useLocation } from 'react-router'

import { useNavigate } from 'common/hooks/useNavigate'

import { useIsAnySwapAffectedUser } from './useIsAnySwapAffectedUser'

const WARNING_PAGE = '/anyswap-affected-users'

export default function RedirectAnySwapAffectedUsers(): null {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  // Detect if the user is affected by the hack
  const isAnySwapAffectedUser = useIsAnySwapAffectedUser()

  useEffect(() => {
    if (isAnySwapAffectedUser && location.pathname !== WARNING_PAGE) {
      // Redirect to warning page
      navigate(WARNING_PAGE)
    }
  }, [isAnySwapAffectedUser, navigate, pathname])

  return null
}
